/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MessageType {
    AI_MESSAGE = 'aiMessage',
    CHARACTER_PHOTOS_UPLOADED = 'characterPhotosUploaded',
    ERROR_MESSAGE = 'errorMessage',
    NEW_CONVERSATION = 'newConversation',
    NOTIFICATION = 'notification',
    PERFORMER_CONTRACT_DECLINED = 'performerContractDeclined',
    SUPPORT_MESSAGE = 'supportMessage',
    SYSTEM_MESSAGE = 'systemMessage',
    TYPING = 'typing',
    UPDATED_CONVERSATION = 'updatedConversation',
    USER_MESSAGE = 'userMessage',
}
